var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13c-.2 0-.3 0-.5-.1l-8.7-5c-.2-.2-.4-.4-.5-.7s0-.5.1-.8c.3-.4.7-.7 1.1-1l7-4c.9-.5 2.1-.5 3 0l7 4c.4.3.8.6 1.1 1.1.1.2.2.5.1.8-.1.3-.2.5-.5.6l-8.7 5c-.2.1-.3.1-.5.1zM5 6.8l7 4 7-4-6.5-3.7c-.3-.2-.7-.2-1 0L5 6.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23c-.5 0-1-.1-1.5-.4l-7-4c-.5-.3-.8-.6-1.1-1.1-.3-.5-.4-1-.4-1.5V8c0-.5.1-1 .4-1.5l.1-.1c.3-.4.9-.5 1.3-.3l8.7 5c.3.2.5.5.5.9v10c0 .6-.4 1-1 1zM4 8.5V16c0 .2 0 .3.1.5s.2.3.4.4l6.5 3.7v-8L4 8.5zM3.3 7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23c-.6 0-1-.4-1-1V12c0-.4.2-.7.5-.9l8.7-5c.4-.3 1-.1 1.3.3l.1.1c.3.5.4 1 .4 1.5v8c0 .5-.1 1-.4 1.5-.3.5-.6.8-1.1 1.1l-7 4c-.5.3-1 .4-1.5.4zm1-10.4v8l6.5-3.7c.1-.1.3-.2.4-.4.1-.2.1-.3.1-.5V8.5l-7 4.1zM20.7 7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.8c927b37.svg";
export { ForwardRef as ReactComponent };